import React from 'react';

export const VideoIcon = (props) => {
  return (
    <svg viewBox='0 0 14 10' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/type/video' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <path
          fill='currentColor'
          d='M9.2285717,9.714286 L0.9714286,9.714286 C0.434923399,9.714286 -1.14575016e-13,9.2793626 -1.14575016e-13,8.7428574 L-1.14575016e-13,0.9714286 C-1.14575016e-13,0.434923399 0.434923399,1.78523862e-13 0.9714286,1.78523862e-13 L9.2285717,1.78523862e-13 C9.7650769,1.78523862e-13 10.2000003,0.434923399 10.2000003,0.9714286 L10.2000003,2.94342866 L12.8325718,1.06371432 C12.9803487,0.958495533 13.1744443,0.944397053 13.3358752,1.02715597 C13.4973062,1.10991489 13.5991643,1.27573645 13.6000004,1.4571429 L13.6000004,8.2571431 C13.5991643,8.43854955 13.4973062,8.60437111 13.3358752,8.68713003 C13.1744443,8.76988895 12.9803487,8.75579047 12.8325718,8.65057168 L10.2000003,6.77085734 L10.2000003,8.7428574 C10.2000003,9.2793626 9.7650769,9.714286 9.2285717,9.714286 Z'
          fillRule='nonzero'
        ></path>
      </g>
    </svg>
  );
};
